/* OSM Konfor — theme scripts (no dependencies) */
(function () {
  'use strict';

  var theme = window.theme || { routes: {}, strings: {}, cartType: 'drawer' };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- helpers ---------- */
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }
  function parseHTML(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function rootUrl(path) {
    var root = theme.routes.root || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + path.replace(/^\//, '');
  }

  var toastTimer;
  function toast(message) {
    var el = qs('[data-toast]');
    if (!el || !message) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- drawers ---------- */
  // Drawers rendered inside sections (menu, filters) are moved to <body> so the
  // sticky header's stacking context can't trap them under the page overlay.
  function portalDrawers(root) {
    qsa('[data-drawer]', root).forEach(function (drawer) {
      if (drawer.parentElement === document.body) return;
      if (drawer.id) {
        qsa('#' + drawer.id).forEach(function (old) {
          if (old !== drawer && old.parentElement === document.body) old.remove();
        });
      }
      document.body.appendChild(drawer);
    });
  }

  var overlay = qs('[data-page-overlay]');
  var openDrawerEl = null;
  var lastFocus = null;

  function openDrawer(name) {
    var drawer = qs('[data-drawer="' + name + '"]');
    if (!drawer) return false;
    if (openDrawerEl && openDrawerEl !== drawer) closeDrawer(true);
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-visible');
    document.body.classList.add('scroll-locked');
    openDrawerEl = drawer;
    var focusTarget = qs('[data-predictive-input]', drawer) || qs('.drawer__panel', drawer);
    setTimeout(function () { if (focusTarget) focusTarget.focus({ preventScroll: true }); }, 60);
    return true;
  }

  function closeDrawer(keepOverlay) {
    if (!openDrawerEl) return;
    openDrawerEl.classList.remove('is-open');
    openDrawerEl.setAttribute('aria-hidden', 'true');
    openDrawerEl = null;
    if (!keepOverlay) {
      if (overlay) overlay.classList.remove('is-visible');
      document.body.classList.remove('scroll-locked');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var name = opener.getAttribute('data-drawer-open');
      if (name === 'cart' && theme.cartType === 'page') return;
      if (openDrawer(name)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) {
      closeDrawer();
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer();
    closeModal();
    closeLightbox();
  });

  /* ---------- modals ---------- */
  var openModalEl = null;
  function openModal(id) {
    var modal = document.getElementById(id);
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('scroll-locked');
    openModalEl = modal;
  }
  function closeModal() {
    if (!openModalEl) return;
    openModalEl.classList.remove('is-open');
    openModalEl.setAttribute('aria-hidden', 'true');
    openModalEl = null;
    if (!openDrawerEl) document.body.classList.remove('scroll-locked');
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-modal-open]');
    if (opener) { openModal(opener.getAttribute('data-modal-open')); return; }
    if (e.target.closest('[data-modal-close]') || (e.target.matches && e.target.matches('[data-modal]'))) closeModal();
  });

  /* ---------- header ---------- */
  function initHeader() {
    var header = qs('[data-header]');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- announcement ---------- */
  function initAnnouncement(root) {
    qsa('[data-announcement]', root).forEach(function (bar) {
      var items = qsa('.announcement__item', bar);
      if (items.length < 2 || bar._timer) return;
      var i = 0;
      var interval = parseInt(bar.getAttribute('data-interval'), 10) || 4000;
      bar._timer = setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, interval);
    });
  }

  /* ---------- hero slideshow ---------- */
  function initHero(root) {
    qsa('[data-hero]', root).forEach(function (hero) {
      if (hero._hero) return;
      var slides = qsa('[data-hero-slide]', hero);
      var dots = qsa('[data-hero-dot]', hero);
      var autoplay = hero.getAttribute('data-autoplay') === 'true' && !reduceMotion;
      var interval = parseInt(hero.getAttribute('data-interval'), 10) || 6000;
      var current = 0, timer = null;
      hero.style.setProperty('--hero-interval', interval + 'ms');
      if (!autoplay) hero.setAttribute('data-autoplay', 'false');

      function go(index) {
        if (!slides.length) return;
        current = (index + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
        dots.forEach(function (d, i) {
          d.classList.remove('is-active');
          d.setAttribute('aria-selected', i === current ? 'true' : 'false');
        });
        if (dots[current]) {
          void dots[current].offsetWidth; // restart progress animation
          dots[current].classList.add('is-active');
        }
        restart();
      }
      function restart() {
        clearTimeout(timer);
        if (autoplay && slides.length > 1 && !hero.classList.contains('is-paused')) {
          timer = setTimeout(function () { go(current + 1); }, interval);
        }
      }

      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-hero-dot'), 10)); }); });
      var prev = qs('[data-hero-prev]', hero), next = qs('[data-hero-next]', hero);
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });

      // swipe
      var startX = null;
      hero.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 50) go(current + (dx < 0 ? 1 : -1));
        startX = null;
      });

      hero.addEventListener('mouseenter', function () { hero.classList.add('is-paused'); clearTimeout(timer); });
      hero.addEventListener('mouseleave', function () { hero.classList.remove('is-paused'); restart(); });
      document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(timer); else restart(); });

      hero._hero = { go: go, slides: slides };
      restart();
    });
  }

  /* ---------- horizontal sliders ---------- */
  function initSliders(root) {
    qsa('[data-slider-prev], [data-slider-next]', root).forEach(function (btn) {
      if (btn._bound) return;
      btn._bound = true;
      var id = btn.getAttribute('data-slider-prev') || btn.getAttribute('data-slider-next');
      var dir = btn.hasAttribute('data-slider-prev') ? -1 : 1;
      btn.addEventListener('click', function () {
        var slider = document.getElementById(id);
        if (!slider) return;
        var item = qs('.slider__item', slider);
        var step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(slider).columnGap || 0) : slider.clientWidth * 0.8;
        slider.scrollBy({ left: dir * step, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---------- category slices ---------- */
  function initSlices(root) {
    var desktop = window.matchMedia('(min-width: 990px)');
    qsa('.slices', root).forEach(function (wrap) {
      if (wrap._bound) return;
      wrap._bound = true;
      var slices = qsa('[data-slice]', wrap);
      function activate(el) {
        if (!desktop.matches) return;
        slices.forEach(function (s) { s.classList.toggle('is-open', s === el); });
      }
      slices.forEach(function (s) {
        s.addEventListener('mouseenter', function () { activate(s); });
        s.addEventListener('focus', function () { activate(s); });
      });
    });
  }

  /* ---------- footer accordions ---------- */
  function initFooter() {
    var mq = window.matchMedia('(min-width: 990px)');
    function sync() {
      qsa('.footer__details').forEach(function (d) {
        if (mq.matches) d.setAttribute('open', '');
        else d.removeAttribute('open');
      });
    }
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
  }

  /* ---------- reveal on scroll ---------- */
  var revealObserver = null;
  function initReveal(root) {
    if (!document.body.classList.contains('has-reveal')) return;
    if (theme.designMode || reduceMotion || !('IntersectionObserver' in window)) {
      document.body.classList.add('no-reveal');
      return;
    }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    }
    qsa('[data-reveal]:not(.is-revealed)', root).forEach(function (el) { revealObserver.observe(el); });
  }

  /* ---------- parallax ---------- */
  function initParallax() {
    var items = qsa('[data-parallax]');
    if (!items.length || reduceMotion) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var frame = el.parentElement;
        var r = frame.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var progress = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
        progress = Math.max(-1, Math.min(1, progress));
        el.style.transform = 'translate3d(0,' + (progress * r.height * 0.08).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- cart ---------- */
  function renderCartDrawer(html) {
    if (!html) return;
    var doc = parseHTML(html);
    var fresh = qs('[data-cart-drawer-content]', doc);
    var current = qs('[data-cart-drawer-content]');
    if (fresh && current) current.replaceWith(fresh);
    var count = fresh ? parseInt(fresh.getAttribute('data-cart-count'), 10) : null;
    if (count !== null && !isNaN(count)) updateCartCount(count);
  }

  function updateCartCount(count) {
    qsa('[data-cart-count-bubble]').forEach(function (b) {
      b.textContent = count;
      b.hidden = count === 0;
    });
  }

  function cartRequest(url, body) {
    body.sections = 'cart-drawer';
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || data.status) {
          var err = new Error(data.description || data.message || theme.strings.cartError);
          throw err;
        }
        return data;
      });
    });
  }

  function addToCart(variantId, quantity, button) {
    if (button) button.classList.add('is-loading');
    return cartRequest((theme.routes.cartAdd || '/cart/add') + '.js', {
      items: [{ id: Number(variantId), quantity: quantity || 1 }]
    }).then(function (data) {
      if (theme.cartType === 'page') {
        window.location.href = theme.routes.cart || '/cart';
        return;
      }
      renderCartDrawer(data.sections && data.sections['cart-drawer']);
      openDrawer('cart');
    }).catch(function (err) {
      toast(err.message || theme.strings.cartError);
    }).finally(function () {
      if (button) button.classList.remove('is-loading');
    });
  }

  function changeLine(key, quantity) {
    var content = qs('[data-cart-drawer-content]');
    if (content) content.classList.add('is-loading');
    return cartRequest((theme.routes.cartChange || '/cart/change') + '.js', { id: key, quantity: quantity })
      .then(function (data) { renderCartDrawer(data.sections && data.sections['cart-drawer']); })
      .catch(function (err) {
        toast(err.message);
        if (content) content.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    var updater = e.target.closest('[data-cart-update]');
    if (updater) {
      e.preventDefault();
      changeLine(updater.getAttribute('data-cart-update'), parseInt(updater.getAttribute('data-quantity'), 10));
      return;
    }
    var quick = e.target.closest('[data-quick-add-variant]');
    if (quick) {
      e.preventDefault();
      if (quick.disabled) return;
      addToCart(quick.getAttribute('data-quick-add-variant'), 1, quick).then(function () {
        var panel = quick.closest('[data-quick-add]');
        if (panel) panel.classList.remove('is-open');
      });
      return;
    }
    var toggle = e.target.closest('[data-quick-toggle]');
    if (toggle) {
      e.preventDefault();
      var panel = toggle.parentElement.querySelector('[data-quick-add]');
      var willOpen = panel && !panel.classList.contains('is-open');
      qsa('[data-quick-add].is-open').forEach(function (p) { p.classList.remove('is-open'); });
      qsa('[data-quick-toggle].is-active').forEach(function (t) { t.classList.remove('is-active'); });
      if (panel && willOpen) { panel.classList.add('is-open'); toggle.classList.add('is-active'); }
      return;
    }
    if (!e.target.closest('[data-quick-add]')) {
      qsa('[data-quick-add].is-open').forEach(function (p) { p.classList.remove('is-open'); });
      qsa('[data-quick-toggle].is-active').forEach(function (t) { t.classList.remove('is-active'); });
    }
  });

  document.addEventListener('input', debounce(function (e) {
    if (!e.target.matches('[data-cart-note]')) return;
    fetch((theme.routes.cart || '/cart') + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: e.target.value })
    });
  }, 500));

  // Cart page: auto-submit quantity changes
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit]') && e.target.form) e.target.form.submit();
  });

  /* ---------- product page ---------- */
  function initProduct(root) {
    qsa('[data-product-section]', root).forEach(function (section) {
      if (section._product) return;
      section._product = true;
      var jsonEl = qs('[data-product-json]', section);
      var data;
      try { data = JSON.parse(jsonEl.textContent); } catch (err) { return; }

      var picker = qs('[data-variant-picker]', section);
      var form = qs('form[action*="/cart/add"]', section);
      var idInput = qs('[data-variant-input]', section);
      var addBtn = qs('[data-add-button]', section);
      var addLabel = qs('[data-add-label]', section);
      var stock = qs('[data-stock]', section);
      var stockLabel = qs('[data-stock-label]', section);
      var sticky = qs('[data-sticky-buy]', section);
      var gallery = qs('[data-gallery]', section);
      var currentVariant = data.variants.find(function (v) { return idInput && String(v.id) === idInput.value; }) || data.variants[0];

      function selectedOptions() {
        if (!picker) return currentVariant ? currentVariant.options : [];
        return qsa('fieldset[data-option-index]', picker).map(function (fs) {
          var checked = qs('input:checked', fs);
          return checked ? checked.value : null;
        });
      }

      function findVariant(options) {
        return data.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === options[i]; });
        });
      }

      function markAvailability(options) {
        if (!picker) return;
        qsa('fieldset[data-option-index]', picker).forEach(function (fs) {
          var idx = parseInt(fs.getAttribute('data-option-index'), 10);
          qsa('input', fs).forEach(function (input) {
            var test = options.slice();
            test[idx] = input.value;
            var match = data.variants.find(function (v) {
              return v.available && v.options.every(function (o, i) { return o === test[i]; });
            });
            input.classList.toggle('is-unavailable', !match);
          });
          var label = qs('[data-option-selected]', fs);
          if (label) label.textContent = options[idx] || '';
        });
      }

      function setButtons(available, label) {
        [addBtn, qs('[data-sticky-add]', section)].forEach(function (b) { if (b) b.disabled = !available; });
        if (addLabel) addLabel.textContent = label;
        var stickyLabel = qs('[data-sticky-label]', section);
        if (stickyLabel) stickyLabel.textContent = label;
      }

      function update() {
        var options = selectedOptions();
        var variant = findVariant(options);
        markAvailability(options);
        if (!variant) {
          setButtons(false, theme.strings.unavailable);
          return;
        }
        currentVariant = variant;
        if (idInput) idInput.value = variant.id;

        var price = qs('[data-price]', section);
        if (price) {
          var cur = qs('[data-price-current]', price);
          var cmp = qs('[data-price-compare]', price);
          var badge = qs('[data-price-badge]', price);
          if (cur) cur.innerHTML = variant.price;
          if (cmp) { cmp.innerHTML = variant.compare_at_price || ''; cmp.hidden = !variant.compare_at_price; }
          if (badge) { badge.textContent = variant.discount ? '-%' + variant.discount : ''; badge.hidden = !variant.discount; }
          price.classList.toggle('price--sale', !!variant.compare_at_price);
        }
        var stickyPrice = qs('[data-sticky-price]', section);
        if (stickyPrice) stickyPrice.innerHTML = variant.price;

        setButtons(variant.available, variant.available ? theme.strings.addToCart : theme.strings.soldOut);
        if (stock) {
          stock.classList.toggle('stock--in', variant.available);
          stock.classList.toggle('stock--out', !variant.available);
        }
        if (stockLabel && stock) {
          stockLabel.textContent = variant.available ? theme.strings.inStock : theme.strings.soldOut;
        }

        if (variant.media_id && gallery) {
          var item = qs('[data-media-id="' + variant.media_id + '"]', gallery);
          if (item) {
            qsa('.gallery__item', gallery).forEach(function (g) { g.classList.toggle('is-current', g === item); });
            if (gallery.scrollWidth > gallery.clientWidth + 4) {
              gallery.scrollTo({ left: item.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
            }
          }
        }

        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      if (picker) {
        picker.addEventListener('change', update);
        markAvailability(selectedOptions());
      }

      // quantity steppers
      qsa('[data-qty-step]', section).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var input = btn.parentElement.querySelector('input');
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-step'), 10));
          input.value = next;
        });
      });

      // add to cart
      if (form && theme.cartType !== 'page') {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (!currentVariant || !currentVariant.available) return;
          var qty = parseInt((qs('input[name="quantity"]', form) || {}).value, 10) || 1;
          addToCart(idInput.value, qty, addBtn);
        });
      }

      // sticky buy bar
      if (sticky && addBtn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          document.body.classList.toggle('has-sticky-buy', show);
        });
        io.observe(addBtn);
        var stickyAdd = qs('[data-sticky-add]', sticky);
        if (stickyAdd) stickyAdd.addEventListener('click', function () {
          if (picker && !currentVariant) { picker.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
          if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
        });
      }

      // gallery pager (mobile)
      var pager = qs('[data-gallery-current]', section);
      if (gallery && pager) {
        gallery.addEventListener('scroll', debounce(function () {
          var w = gallery.clientWidth || 1;
          pager.textContent = Math.round(gallery.scrollLeft / w) + 1;
        }, 60), { passive: true });
      }

      // lightbox
      var lightbox = qs('[data-lightbox]', section);
      if (lightbox) {
        qsa('[data-lightbox-open]', section).forEach(function (btn) {
          btn.addEventListener('click', function () {
            var items = qsa('.gallery__item', section);
            var target = btn.closest('.gallery__item');
            var imageIndex = items.filter(function (it) { return it.classList.contains('gallery__item--image'); }).indexOf(target);
            lightbox.classList.add('is-open');
            lightbox.setAttribute('aria-hidden', 'false');
            document.body.classList.add('scroll-locked');
            var track = qs('[data-lightbox-track]', lightbox);
            requestAnimationFrame(function () { track.scrollLeft = Math.max(0, imageIndex) * track.clientWidth; });
            currentLightbox = lightbox;
          });
        });
        qs('[data-lightbox-close]', lightbox).addEventListener('click', closeLightbox);
      }

      // share
      qsa('[data-share-copy]', section).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var url = btn.getAttribute('data-share-copy');
          if (navigator.share) { navigator.share({ url: url }).catch(function () {}); return; }
          if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { toast(btn.textContent.trim() + ' ✓'); });
        });
      });
    });
  }

  var currentLightbox = null;
  function closeLightbox() {
    if (!currentLightbox) return;
    currentLightbox.classList.remove('is-open');
    currentLightbox.setAttribute('aria-hidden', 'true');
    currentLightbox = null;
    if (!openDrawerEl && !openModalEl) document.body.classList.remove('scroll-locked');
  }

  /* ---------- product recommendations ---------- */
  function initRecommendations(root) {
    qsa('[data-recommendations]', root).forEach(function (el) {
      if (el._loaded || qs('[data-recommendations-content]', el)) return;
      el._loaded = true;
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var fresh = qs('[data-recommendations]', parseHTML(html));
        if (fresh && fresh.innerHTML.trim()) {
          el.innerHTML = fresh.innerHTML;
          initReveal(el);
          syncWishlist();
        }
      }).catch(function () {});
    });
  }

  /* ---------- collection: sort + filters ---------- */
  function initCollection(root) {
    qsa('[data-sort-select]', root).forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
    qsa('[data-filter-form]', root).forEach(function (form) {
      form.addEventListener('submit', function () {
        qsa('input[type="number"]', form).forEach(function (input) { if (input.value === '') input.disabled = true; });
      });
    });
  }

  /* ---------- predictive search ---------- */
  function initPredictiveSearch() {
    var input = qs('[data-predictive-input]');
    var results = qs('[data-predictive-results]');
    var popular = qs('[data-predictive-popular]');
    if (!input || !results || !theme.routes.predictiveSearch) return;
    var controller = null;

    var run = debounce(function () {
      var q = input.value.trim();
      if (popular) popular.hidden = q.length > 0;
      if (q.length < 2) { results.innerHTML = ''; return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = theme.routes.predictiveSearch +
        '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search' +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var content = qs('[data-predictive-content]', parseHTML(html));
          results.innerHTML = content ? content.outerHTML : '';
        })
        .catch(function () {});
    }, 260);

    input.addEventListener('input', run);
  }

  /* ---------- wishlist ---------- */
  var WISHLIST_KEY = 'osm:wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function setWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) { /* storage unavailable */ }
  }
  function syncWishlist() {
    var list = getWishlist();
    qsa('[data-wishlist-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', list.indexOf(btn.getAttribute('data-wishlist-toggle')) > -1 ? 'true' : 'false');
    });
    qsa('[data-wishlist-count]').forEach(function (b) {
      b.textContent = list.length;
      b.hidden = list.length === 0;
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-wishlist-toggle');
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx > -1) list.splice(idx, 1); else list.unshift(handle);
    setWishlist(list);
    btn.classList.remove('is-pop'); void btn.offsetWidth; btn.classList.add('is-pop');
    syncWishlist();
    var page = qs('[data-wishlist-page]');
    if (page && idx > -1) {
      var item = btn.closest('.grid__item');
      if (item) item.remove();
      if (!getWishlist().length) qs('[data-wishlist-empty]', page).hidden = false;
    }
  });

  function initWishlistPage() {
    var page = qs('[data-wishlist-page]');
    if (!page) return;
    var grid = qs('[data-wishlist-grid]', page);
    var empty = qs('[data-wishlist-empty]', page);
    var list = getWishlist();
    if (!list.length) { empty.hidden = false; return; }
    Promise.all(list.map(function (handle) {
      return fetch(rootUrl('products/' + encodeURIComponent(handle) + '?view=card'))
        .then(function (r) { return r.ok ? r.text() : null; })
        .catch(function () { return null; });
    })).then(function (htmls) {
      var valid = [];
      htmls.forEach(function (html, i) {
        if (!html || html.indexOf('card') === -1) return;
        valid.push(list[i]);
        var wrap = document.createElement('div');
        wrap.className = 'grid__item';
        wrap.innerHTML = html;
        grid.appendChild(wrap);
      });
      setWishlist(valid);
      if (!valid.length) empty.hidden = false;
      syncWishlist();
      initReveal(grid);
    });
  }

  /* ---------- misc ---------- */
  function initMisc() {
    // Customer address country default
    qsa('select[data-default]').forEach(function (select) {
      var value = select.getAttribute('data-default');
      qsa('option', select).forEach(function (o) { if (o.value === value) select.value = value; });
    });
    // Login: show password recovery
    qsa('[data-recover-toggle]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var page = link.closest('.account-page');
        if (page) page.classList.add('show-recover');
        var recover = qs('[data-recover-view]');
        if (recover) recover.scrollIntoView({ behavior: 'smooth' });
      });
    });
  }

  /* ---------- init ---------- */
  function initSection(root) {
    portalDrawers(root);
    initAnnouncement(root);
    initHero(root);
    initSliders(root);
    initSlices(root);
    initProduct(root);
    initRecommendations(root);
    initCollection(root);
    initReveal(root);
  }

  function init() {
    initHeader();
    initFooter();
    initParallax();
    initPredictiveSearch();
    initSection(document);
    initWishlistPage();
    syncWishlist();
    initMisc();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { initSection(e.target); syncWishlist(); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('[data-hero-slide]');
    var hero = e.target.closest('[data-hero]');
    if (slide && hero && hero._hero) hero._hero.go(hero._hero.slides.indexOf(slide));
  });
})();
